import React from 'react';
import { notification } from 'antd';
import { fetchTaskExpired, fetchTaskList } from '../../store/task/actions';
import authClient from '../../Auth/Auth';
import env from '../../environment';
import axios from 'axios';
import moment from 'moment';

const typeTranslations = {
	call: 'Llamar',
	doc: 'Pedir documentación',
	other: 'Otro',
	claimoffer: 'Reclamar Oferta',
	comdoc: 'Compromiso de documentación',
	tag: 'Etiquetar',
	claim: 'Reclamar documentación',
	phpanalysis: 'Promotor Analisis',
	firstcall: 'Primera llamada',
	sendbanks: 'Enviar a bancos',
	choosenoffer: 'Selección de oferta',
	analysis: 'Nueva operación en analisis',
	clientappraisal: 'Tasación con Gibobs',
	recommender: 'Recomendador',
	claimappraisal: 'Reclamar tasación',
	sinfoniadocspendingtraspaso: 'Sinfonía documentación traspaso',
	sinfoniadocspendingminuta: 'Sinfonía documentación minuta',
	sinfoniainteraccionbloqueante: 'Reclamar tasación',
	sinfoniainteraccionpending: 'Sinfonía interacción pendiente'
};

const modalClose = (id, dispatch) => {
	axios
		.post(
			`${env.api.url}/v1/hadmin/tasks/edit/${id}`,
			{ notified: true },
			{ headers: { Authorization: `Bearer ${authClient.getToken()}` } }
		)
		.then(() => {
			dispatch(fetchTaskList(undefined));
			//dispatch(fetchTaskExpired(authClient.getToken(), false));
			dispatch(fetchTaskExpired(authClient.getToken(), true));
		})
		.catch((error) => {
			console.log(error);
		});
};

export const openNotification = (task, dispatch) => {
	const dateNow = moment().format();
	notification.config({
		placement: 'top'
	});
	if (task !== undefined) {
		task.map((info) => {
			const key = `${info.id}`;
			const btn = (
				<div
					key={key}
					className="button-gibobs-notifications"
					style={{ cursor: 'pointer' }}
					onClick={() => {
						notification.destroy(key);
						modalClose(info.id, dispatch);
					}}>
					<img src={'/images/arrow_up.png'} />
				</div>
			);
			if (
				info.notification === true &&
				info.notified === false &&
				info.status === 'active' &&
				moment(info.duedDate).isBefore(dateNow)
			) {
				notification.open({
					message: 'Esta tarea acaba de vencer',
					icon: <img src={'/images/remind.svg'} alt="remindIcon" height={24} width={24} />,
					description: (
						<div style={{ marginRight: 4 }} key={key}>
							{info && info.name}{' '}
							<a
								style={{
									color: '#FAAD14',
									fontWeight: 700,
									fontsize: 16,
									lineHeight: '24px',
									textDecoration: 'underline #FAAD14'
								}}
								target="_blank"
								href={`/operations/mortgages/${info && info.operationId}`}>
								{info && info.operationName}
							</a>{' '}
							{info && info?.operationUserName + ' ' + `de ${info?.operationUserSurname}`} de tipo{' '}
							{typeTranslations[info.type]}
						</div>
					),
					btn,
					key,
					duration: 420,
					className: 'notification-gibobs'
				});
			}
		});
	}
};
